<div class="header-left">
  <button
    type="button"
    class="header-icon-button mobile-toggle-btn"
    aria-label="Open navigation"
    [attr.aria-expanded]="navOpen()"
    [attr.aria-controls]="navControls()"
    (click)="toggleMobileSidebar.emit()">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  </button>

  <a class="brand" [routerLink]="homeRoute()" aria-label="InfinitForm, go to Projects">
    <app-logo customClass="if-logo-cabinet" [decorative]="true"></app-logo>
  </a>

  @if (shouldShowCompanyLogo() && currentCompany()?.logo_url && !companyLogoFailed()) {
    <span class="company-divider" aria-hidden="true"></span>
    <img
      class="if-company-logo-cabinet"
      [src]="currentCompany()?.logo_url"
      [alt]="currentCompany()?.name || 'Organization logo'"
      (error)="companyLogoFailed.set(true)" />
  }
</div>

<div class="header-center">
  <ng-content select="[headerSearch]"></ng-content>
</div>

<div class="header-right">
  <!-- First in the row, so a status that comes and goes moves nothing after it. -->
  <ng-content select="[headerStatus]"></ng-content>
  @if (pluginConnected()) {
    <span class="plugin-badge" role="status" title="A CAD plugin is connected to the Plugin API">
      <span class="plugin-dot" aria-hidden="true"></span>
      Plugin connected
    </span>
  }
  @if (badgeText()) {
    <button
      type="button"
      class="license-badge"
      [class]="badgeClass()"
      [attr.aria-label]="'License status: ' + badgeText()"
      (click)="onBadgeClick()">
      {{ badgeText() }}
    </button>
  }
  <ng-content></ng-content>
</div>
